export default __webpack_public_path__ + "static/media/CSP_logo.b1c4460e.png";